import { NavLink } from 'react-router-dom'
import DataTable from '../../../common/data-table/DataTable'
import PageHeader from '../../../layout/page/PageHeader'
import dayjs from 'dayjs'
import { FilterMatchMode } from 'primereact/api'
import { ButtonGroup, Badge } from 'react-bootstrap'
import TrueFalseCell from '../../../common/data-table/TrueFalseCell'
import { useAppSelector } from '../../../../store/hooks'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const categoryLabels: Record<string, { label: string; variant: string }> = {
    contact: { label: 'Contact', variant: 'primary' },
    payment: { label: 'Payment', variant: 'success' },
    clinic: { label: 'Clinic', variant: 'info' },
}

const EmailTemplates = () => {
    const theme = useAppSelector((state) => state.theme.theme)

    const dateTimeBodyTemplate = (rowData: any) => {
        return rowData.created_at !== null
            ? dayjs(rowData.created_at).format('DD-MMM-YYYY @ HH:mm:ss')
            : ''
    }

    const categoryBodyTemplate = (rowData: any) => {
        const cat = categoryLabels[rowData.category] || {
            label: rowData.category,
            variant: 'secondary',
        }
        return (
            <Badge bg={cat.variant} className="text-capitalize">
                {cat.label}
            </Badge>
        )
    }

    const statusTemplate = (rowData: any) => {
        return (
            <TrueFalseCell
                value={rowData.is_active === 1}
                trueLabel="Active"
                falseLabel="Inactive"
            />
        )
    }

    const actionsBodyTemplate = (rowData: any) => {
        return (
            <ButtonGroup size="sm">
                <NavLink
                    to={'/administration/emails/view/' + rowData.id}
                    className="btn btn-outline-primary ms-1"
                >
                    <FontAwesomeIcon icon={faEdit} />
                </NavLink>
            </ButtonGroup>
        )
    }

    return (
        <>
            <PageHeader
                icon="paper-plane"
                iconPrefix="far"
                subtitle="Design and customise automated email templates"
                gradient="linear-gradient(135deg, #6366f1, #4f46e5)"
                header="Email Templates"
                buttons={[
                    {
                        variant: theme === 'dark' ? 'dark' : 'light',
                        label: 'Back to Administration',
                        icon: 'fa-solid fa-arrow-left',
                        url: '/administration',
                    },
                ]}
            />
            <DataTable
                config={{
                    dataRoute: '/administration/email-templates',
                    first: 0,
                    rows: 10,
                    page: 0,
                    sortField: 'category',
                    sortOrder: 1,
                    filters: {
                        global: {
                            value: null,
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                        name: {
                            value: '',
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                        category: {
                            value: '',
                            matchMode: FilterMatchMode.CONTAINS,
                        },
                    },
                    filterDisplay: 'menu',
                }}
                columns={[
                    {
                        field: 'name',
                        header: 'Template Name',
                        sortable: true,
                        filter: true,
                        filterPlaceholder: 'Search',
                    },
                    {
                        field: 'category',
                        header: 'Category',
                        sortable: true,
                        filter: true,
                        filterPlaceholder: 'Search',
                        body: categoryBodyTemplate,
                        fixedCenter: true,
                        alignHeader: 'center',
                        headerStyle: {
                            width: '8.5rem',
                            minWidth: '8.5rem',
                            maxWidth: '8.5rem',
                        },
                        style: {
                            width: '8.5rem',
                            minWidth: '8.5rem',
                            maxWidth: '8.5rem',
                        },
                    },
                    {
                        field: 'is_active',
                        header: 'Status',
                        sortable: true,
                        filter: false,
                        body: statusTemplate,
                        fixedCenter: true,
                        alignHeader: 'center',
                        headerStyle: {
                            width: '7.5rem',
                            minWidth: '7.5rem',
                            maxWidth: '7.5rem',
                        },
                        style: {
                            width: '7.5rem',
                            minWidth: '7.5rem',
                            maxWidth: '7.5rem',
                        },
                    },
                    {
                        field: 'created_at',
                        header: 'Created At',
                        sortable: true,
                        filter: false,
                        dataType: 'date',
                        body: dateTimeBodyTemplate,
                        fixedCenter: true,
                        alignHeader: 'center',
                        headerStyle: {
                            width: '15rem',
                            minWidth: '15rem',
                            maxWidth: '15rem',
                        },
                        style: {
                            width: '15rem',
                            minWidth: '15rem',
                            maxWidth: '15rem',
                        },
                    },
                    {
                        field: 'id',
                        header: 'Actions',
                        sortable: false,
                        body: actionsBodyTemplate,
                        alignHeader: 'center',
                        headerStyle: {
                            maxWidth: '1rem',
                            textAlign: 'center',
                        },
                        style: { maxWidth: '1rem', textAlign: 'center' },
                        toggleVisibility: false,
                    },
                ]}
                globalFilterFields={['name', 'category']}
            />
        </>
    )
}

export default EmailTemplates
